module.exports = __webpack_public_path__ + "img/office_4.1f3c0eaf.jpeg";